import {MediaKind} from '../model';

// Расширения файлов, которые трактуем как фото и как видео.
const IMAGE_EXTENSIONS: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  bmp: 'image/bmp',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  heic: 'image/heic',
  heif: 'image/heif',
  avif: 'image/avif',
};

const VIDEO_EXTENSIONS: Record<string, string> = {
  mp4: 'video/mp4',
  m4v: 'video/mp4',
  webm: 'video/webm',
  mov: 'video/quicktime',
  avi: 'video/x-msvideo',
  mkv: 'video/x-matroska',
  ogv: 'video/ogg',
  '3gp': 'video/3gpp',
};

// Возвращает расширение файла в нижнем регистре без точки.
export function getFileExtension(fileName: string): string {
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex < 0 || dotIndex === fileName.length - 1) return '';
  return fileName.slice(dotIndex + 1).toLowerCase();
}

// Определяет тип материала (фото/видео) по расширению выбранного файла.
// Возвращает null, если расширение не относится ни к фото, ни к видео.
export function detectMediaKind(fileName: string): MediaKind | null {
  const ext = getFileExtension(fileName);
  if (ext in IMAGE_EXTENSIONS) return 'image';
  if (ext in VIDEO_EXTENSIONS) return 'video';
  return null;
}

// Подбирает content-type для загрузки: берём MIME-тип файла, а при его
// отсутствии выводим из расширения.
export function resolveContentType(file: File): string {
  if (file.type) return file.type;
  const ext = getFileExtension(file.name);
  return IMAGE_EXTENSIONS[ext] ?? VIDEO_EXTENSIONS[ext] ?? 'application/octet-stream';
}
